import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    avCountries: null,
    activeCountryId: 56
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
